import { get, internalDestroy, internalPost, internalPut } from '.';
import qs from 'qs';

export const getAccreditations = ({ filters }) => {
  return get(`/accreditations?${qs.stringify(filters)}`);
};

export const getAccreditation = ({ accreditationId, locale }) => {
  return get(`/accreditations/${accreditationId}?locale=${locale}`);
};

export const createAccreditation = ({ payload, locale }) => {
  return internalPost(`/accreditations?locale=${locale}`, payload);
};

export const updateAccreditation = ({ accreditationId, payload, locale }) => {
  return internalPut(
    `/accreditations/${accreditationId}?locale=${locale}`,
    payload,
  );
};

export const deleteAccreditation = ({ accreditationId, payload }) => {
  return internalDestroy(`/accreditations/${accreditationId}`, payload);
};
